import { ConsentType } from "../enums/consent-type";
import { ContractType } from "../enums/contract-type";
import { DocumentType } from '../enums/document-type';
import { ProfessionalSector } from "../enums/contract-type copy";
import { HousingType } from "../enums/housing-type";
import { IncomeSource } from "../enums/income-source";
import { MaritalStatus } from "../enums/marital-status";
import { Nationality } from "../enums/nacionality";
import { NotificationConsent } from "../enums/notification-consent";
import { PrivacyConsent } from "../enums/privacy-consent";
import { Product } from "../enums/product";
import { TextInfoConsent } from "../enums/text-info-consent";
import { WorkingStatus } from "../enums/working-status";
import { UserData } from "../interfaces/data/user-data.interface";
import { Financial } from "../models/financial-data";
import { Person } from "../models/person";
import { Operation } from "../models/subscription";
import { Vehicle } from "../models/vehicle";
import { MapperService } from "./mapper-services";
import { Injectable } from "@angular/core";
import { Data } from "../interfaces/data/data.interface";
import { AddressData } from "../models/adress-data";
import { ArrangementFee } from "../enums/arrangement-fee";

@Injectable({
    providedIn: 'root',
})
export class OperationMapperService extends MapperService<Data, Operation>  {

    protected map(entity: Data): Operation {

        const operacion: Operation =  {

            orderId : entity.userData.order,
            vendorId : entity.userData.vendor,
            partnerId : entity.userData.partner,
            storeId : entity.userData.store,
            additionalCalculations : 'SCORE',
            subscriptionId : entity.userData.idNumber,
            vehicle : this.mapVehicle(entity),
            financialData : this.mapFinancialData(entity),
            holder : this.mapPerson(entity.userData),
            coHolder : null
        };

        return operacion;
    }

    protected mapVehicle (entity: Data) : Vehicle {

        const vehicle: Vehicle = {
            type: 'CAR',
            brand: entity.vehicleData.brand,
            model: entity.vehicleData.model,
            version: entity.vehicleData.version,
            price: entity.vehicleData.price,
            vin: entity.vehicleData.vin,
            modelYear: entity.vehicleData.modelYear,
            mileage: entity.vehicleData.mileage,
            annualMileage: entity.vehicleData.annualMileage,
            plateNumber: entity.vehicleData.plateNumber,
            firstRegistrationDate: entity.vehicleData.firstRegistrationDate
        };

       return vehicle;
    }

    protected mapFinancialData (entity: Data) : Financial{

        const financialData: Financial = {
            duration : +entity.financialData.duration,
            channel : entity.financialData.channel,
            installmentTotalGrossAmount : parseFloat(entity.financialData.installmentTotalGrossAmount.toFixed(2)),
            financedAndInsuranceTotalGrossAmount :  entity.financialData.financedAndInsuranceTotalGrossAmount,
            vat : entity.financialData.vat,
            aprcRate : entity.financialData.aprcRate,
            nominalRate : entity.financialData.nominalRate,
            downPaymentGrossAmount : entity.financialData.downPaymentGrossAmount,
            totalFinancedGrossAmount : entity.financialData.amountFinanced,
            totalInterestGrossAmount : null,
            financialProduct : {id: entity.financialData.financialProduct.id, name: entity.financialData.financialProduct.name},
            formalizationFee :  {
                type: 'FINANCED',
                amount: entity.financialData.formalizationFee.amount,
                percentage: entity.financialData.formalizationFee.percentage,
            },
            totalCreditCost : entity.financialData.totalCreditCost,
            totalAmountDue : entity.financialData.totalAmountDue,
            arrangementFee : {
                code: entity.financialData.arrangementFeeCode ? entity.financialData.arrangementFeeCode : 'G3.95A',
                paymentMode: ArrangementFee.FINANCIADO
            },
            vehicleData : {
                vehicleVersion: entity.vehicleData.version,
                vehicleRegistrationNumber : '',
                vehicleRegistrationDate: new Date(entity.vehicleData.firstRegistrationDate),
                vehicleType: entity.vehicleData.type
            },
            deferralType : entity.financialData.deferralType ? entity.financialData.deferralType : '',
            productType : Product.MC,
            material : entity.financialData.material ? entity.financialData.material : '',
            promotion : entity.financialData.promotion ? entity.financialData.promotion : '' ,
            secureCode : entity.financialData.secureCode,
            residualValue : entity.financialData.residualValue
        };

        return financialData;
    }

    protected mapPerson(entity: UserData) : Person{
        const person : Person = {
            //customerNumber : '',//this.appData.vehicle.type?,
            personalData : {
                documentType : DocumentType.DNI,
                nif: '0' + entity.identification.dni,
                nifExpiryDate: entity.identification.expirationNif, // ???
                title : entity.personalDataInfo.gender,
                firstName : entity.personalDataInfo.textName,
                firstSurename : entity.personalDataInfo.textFirst,
                secondSurename : entity.personalDataInfo.textSecond,
                birthDate : entity.personalDataBirth.birthDate,
                nationalityCountry : {
                    countryCode : entity.personalDataBirth.country.code,
                    nationality : Nationality [entity.personalDataBirth.country.regime as keyof typeof Nationality]
                },
                residenceCountry : 'ES',
                birthCountry : entity.personalDataBirth.country.code,
                maritalStatus : MaritalStatus [entity.additionalDataFirst.maritalStatus as keyof typeof MaritalStatus],
                numberOfChildren: Number(entity.additionalDataFirst.childrenNumber),
                monthlyExpenses: null,
                housingType: HousingType [entity.houseType.typeHousingContract as keyof typeof HousingType],
                housingSeniority: entity.houseType.year,
                housingCosts: entity.houseType.cost ? entity.houseType.cost : 0,
                othersCosts: 5,

            },
            businessData : {
                activityCountry: "ES",
                addressData : this.mapAddressData(entity),
                companyName: entity.workingSituation.company ? entity.workingSituation.company : entity.workingSituation.companyName,
                contractType: ContractType[entity.contractType.workContractType as keyof typeof ContractType],
                endDate: entity.workingSituation.lastJobText ? new Date(parseInt(entity.workingSituation.lastJobText), 0, 1) : entity.contractType.temporaryWorkingEndDate,
                profession: this.mapProfession(entity),
                professionalSector: this.mapProfessionalSector(entity),
                professionalBranch: this.mapProfessionalBranch(entity),
                startDate: entity.contractType.stableWorkingStartDate ?
                    entity.contractType.stableWorkingStartDate : entity.contractType.temporaryWorkingStartDate ?
                    entity.contractType.temporaryWorkingStartDate : new Date(),
                workingStatus: WorkingStatus [entity.workingSituation.workStatus as keyof typeof WorkingStatus],
                income : {
                    amount: entity.contractType.monthlyNetIncome ? entity.contractType.monthlyNetIncome : entity.workingSituation.revenue ? entity.workingSituation.revenue : 0 ,
                    incomeSource: IncomeSource [entity.workingSituation.sectorText as keyof typeof IncomeSource],
                    incomeDetail : entity.workingSituation.monthlyNetIncomeLabel
                },
                laborSeniority : ((entity.workingSituation.workStatus == WorkingStatus.WORKING) && (entity.contractType.workContractType  == ContractType.FIXED)) ?
                    (entity.contractType.stableWorkingStartDate ? entity.contractType.stableWorkingStartDate : new Date())
                    : null,

            },
            contactData : {
                personalMobilePhone: entity.contactDataInfo.telephone,
                personalEmail: entity.contactDataInfo.email,
                businessLandLinePhone: '914625228'
            },
            addressData : {
                streetType: entity.houseAddress.streetType.code,
                streetName: entity.houseAddress.streetName,
                streetNumber: entity.houseAddress.streetNumber,
                zipCode: entity.houseAddress.postalCode,
                city: entity.houseAddress.city,
                province: entity.houseAddress.province.code,
                country:  'ES',
            },
            privacyConsentData : [
                {
                    consentType: ConsentType.EXTERNAL_SERVICES,
                    privacyConsent: PrivacyConsent.ACCEPTED,
                    textInfoConsent: TextInfoConsent.ACCEPTED,
                    notificationConsent: NotificationConsent.NOT_ACCEPTED,
                    notificationPhoneNumber: entity.contactDataInfo.telephone,
                    notificationEmailAddress: entity.contactDataInfo.email,
                    consentDate: new Date()
                },
                {
                    consentType: ConsentType.switchPrivacy1,
                    privacyConsent: entity.privacySettings.switchPrivacy1 ? PrivacyConsent.ACCEPTED : PrivacyConsent.NOT_ACCEPTED,
                    textInfoConsent: entity.privacySettings.switchPrivacy1 ? TextInfoConsent.ACCEPTED : TextInfoConsent.NOT_ACCEPTED,
                    notificationConsent: entity.privacySettings.switchPrivacy1 ? NotificationConsent.MANUAL : NotificationConsent.NOT_ACCEPTED,
                    notificationPhoneNumber: entity.contactDataInfo.telephone,
                    notificationEmailAddress: entity.contactDataInfo.email,
                    consentDate: new Date()
                },
                {
                    consentType: ConsentType.switchPrivacy2,
                    privacyConsent: entity.privacySettings.switchPrivacy2 ? PrivacyConsent.ACCEPTED : PrivacyConsent.NOT_ACCEPTED,
                    textInfoConsent: entity.privacySettings.switchPrivacy2 ? TextInfoConsent.ACCEPTED : TextInfoConsent.NOT_ACCEPTED,
                    notificationConsent: entity.privacySettings.switchPrivacy2 ? NotificationConsent.MANUAL : NotificationConsent.NOT_ACCEPTED,
                    notificationPhoneNumber: entity.contactDataInfo.telephone,
                    notificationEmailAddress: entity.contactDataInfo.email,
                    consentDate: new Date()
                },
                {
                    consentType: ConsentType.switchPrivacy3,
                    privacyConsent: entity.privacySettings.switchPrivacy3 ? PrivacyConsent.ACCEPTED : PrivacyConsent.NOT_ACCEPTED,
                    textInfoConsent: entity.privacySettings.switchPrivacy3 ? TextInfoConsent.ACCEPTED : TextInfoConsent.NOT_ACCEPTED,
                    notificationConsent: entity.privacySettings.switchPrivacy3 ? NotificationConsent.MANUAL : NotificationConsent.NOT_ACCEPTED,
                    notificationPhoneNumber: entity.contactDataInfo.telephone,
                    notificationEmailAddress: entity.contactDataInfo.email,
                    consentDate: new Date()
                },
                {
                    consentType: ConsentType.switchPrivacy4,
                    privacyConsent: entity.privacySettings.switchPrivacy4 ? PrivacyConsent.ACCEPTED : PrivacyConsent.NOT_ACCEPTED,
                    textInfoConsent: entity.privacySettings.switchPrivacy4 ? TextInfoConsent.ACCEPTED : TextInfoConsent.NOT_ACCEPTED,
                    notificationConsent: entity.privacySettings.switchPrivacy4 ? NotificationConsent.MANUAL : NotificationConsent.NOT_ACCEPTED,
                    notificationPhoneNumber: entity.contactDataInfo.telephone,
                    notificationEmailAddress: entity.contactDataInfo.email,
                    consentDate: new Date()
                }
            ]
        };

        return person;
    }

    protected mapProfessionalSector(entity: UserData): ProfessionalSector {
        if(entity.workingSituation.workStatus == WorkingStatus.WORKING)
            return entity.workingSituation.sector?.code;

        return ProfessionalSector [(entity.workingSituation.sectorText ? entity.workingSituation.sectorText
            : entity.workingSituation.notWorkingSituation?.sectorCode) as keyof typeof ProfessionalSector];
    }

    protected mapProfessionalBranch(entity: UserData): string {
        if(entity.workingSituation.workStatus == WorkingStatus.WORKING)
            return entity.workingSituation.branch?.fieldCode;

        if (this.mapProfessionalSector(entity) == ProfessionalSector.MIXED)
            return '';
        return entity.workingSituation.branchText ? entity.workingSituation.branchText
                    : entity.workingSituation.notWorkingSituation?.bankProfessionalStatusCode ?
                    entity.workingSituation.notWorkingSituation?.bankProfessionalStatusCode : '';
    }

    protected mapProfession(entity: UserData): string {
        if(entity.workingSituation.workStatus == WorkingStatus.WORKING)
            return entity.workingSituation.profession?.professionCode;

        return entity.workingSituation.professionText ?
                entity.workingSituation.professionText :
                    entity.workingSituation.notWorkingSituation?.professionCode ?
                    entity.workingSituation.notWorkingSituation?.professionCode : '';
    }

    protected mapAddressData (entity: UserData) : AddressData {

        const adressData: AddressData = {
            streetType: entity.houseAddress.streetType.code,
            streetName: entity.houseAddress.streetName,
            streetNumber: entity.houseAddress.streetNumber,
            zipCode: entity.houseAddress.postalCode,
            city: entity.houseAddress.city,
            province: entity.houseAddress.province.code,
            country: 'ES'
        };

       return adressData;
    }
}
